import React, {useState} from 'react';
import {useEffect}       from "react";
import Select            from "react-select"
import "./OrderItem.css";

const OrderItem = ({initial, name, order, setOrder}) =>{
    const [val, setVal] = useState();
    // const options = [
    //     {value: 1, label: 1},
    //     {value: 2, label: 2},
    //     {value: 3, label: 3},
    //     {value: 4, label: 4}
    // ]

    // const changeHandler = (e) =>{
    //     setOrder(order.map((item, i)=>{
    //         if(item === initial){
    //             return e.value;
    //         }else if(item === e.value){
    //             return initial;
    //         }else{
    //             return item
    //         }
    //     }))
    // }
    
    useEffect(()=>{
        setVal({value: initial, label: initial});
    }, [order])
        
    const customStyles = {
        singleValue: (provided) => ({
            ...provided,
            outline:            "none",
            backgroundColor:    "#324F71",
            color:              "var(--darkblue)",
            border:             "none",
            borderRadius:       "8px",
            height:             "80%",
            fontSize:           "1.255rem",
            fontWeight:         "400",
            zIndex:             "998",
            marginTop:          window.innerWidth > 500 
                                    ? "16px" 
                                    : "22px",
            marginLeft:         window.innerWidth > 500 
                                    ? "32px" 
                                    : "26px"
        }),
        control: (provided,state) => ({
            ...provided,
            cursor:             "not-allowed",
            backgroundColor:    "#324F71",
            outline:            "none",
            border:             0,
            boxShadow:          "none",
            color:              "var(--darkblue)",
            height:             "100%",
        }),
        valueContainer: (provided) => ({
            ...provided,
            outline:            "none",
            border:             "none",
            height:             "100%",
            margin:             "0",
            fontSize:           "1.25rem"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            outline:            "none",
            border:             "none",
            marginTop:          "-3px"
        }),
        indicatorSeparator: () =>({
            display:            "none"
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor:    "#324F71",
            marginTop:          "-4px",
            zIndex:             "999"
        }),
        container: (provided)=>({
            ...provided,
            height: "55px",
        })
    };

    return (
        <div className = "orderItem">
            <div className = "orderItemNameContainer">
                <p>{name}</p>
            </div>
            <div>
                <Select className    = "reactSelect" 
                        isSearchable = {false} 
                        value        = {val} 
                        defaultValue = {{label: 1, value: 1}}     
                        styles       = {customStyles}/>
            </div> 
        </div>
    )
}

export default OrderItem;